<template>
  <div class="app-header-placeholder">
    <div class="app-header-vue" :style="{ background: background }">
      <div class="header_left">
        <slot name="left">
          <van-icon
            v-if="isback"
            class="header_i_back"
            @click="onClickLeft"
            name="arrow-left"
          />
        </slot>
      </div>
      <div class="header_title" @click="dbclick">
        {{ title }}
      </div>
      <div class="header_right" @click="onClickRight">
        <slot name="right">
          {{ rightText }}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * /////////// prop ///////////
 * {title:String} 标题，默认值""，可选值任意字符串
 * {isback:String} 是否展示返回键，默认值展示，传入空字符串即可隐藏返回按钮
 * {url:String} 点击返回键跳转的路由，默认值返回上一页，可传入任意页面路由
 * {righturl:String} 点击右侧区域跳转的路由，默认不跳转，可传入任意页面路由
 * {rightText:String} 右侧区域文字，默认不显示，可选值任意字符串
 * {background:String} 头部栏背景色，默认透明，可选值任意可被css3解析的颜色值
 *
 * /////////// event ///////////
 * clickRight:Function 点击右侧区域事件，事件参数为一个回调方法，调用此回调方法阻止路由跳转
 * clickLeft:Function 点击左侧区域事件，事件参数为一个回调方法，调用此回调方法阻止路由跳转
 * dbclick:Function 双击标题事件
 *
 * /////////// slot /////////////
 * right->右侧区域插槽
 * left->左侧区域插槽
 */
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    isback: {
      type: String,
      default: "1",
    },
    url: {
      type: String,
      default: "",
    },
	clickLeft:{
		type: String,
		default: "",
	},
    righturl: {
      type: String,
    },
    rightText: {
      type: String,
      default: "",
    },
    background: {
      type: String,
      default: "transparent",
    },
  },
  data() {
    return {
      lastClick: -1,
    };
  },
  methods: {
    dbclick() {
      let now = new Date().getTime();
      if (now - this.lastClick <= 500) {
        this.$emit("dbclick", "安迪烦的");
      }
      this.lastClick = now;
    },
    onClickLeft() {
      this.onClickBtn("clickLeft", this.url);
    },
    onClickRight() {
      this.onClickBtn("clickRight", this.righturl);
    },
    onClickBtn(event, url) {
      let res = true;
      this.$emit(event, () => {
        res = false;
      });
      if (!res || url == undefined) {
        return;
      }
      if (url === "") {
        this.$router.go(-1);
      } else {
        this.$router.push(url);
      }
    },
  },
};
</script>

<style scoped="scoped">
.app-header-vue {
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.header_left,
.header_right {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.header_left {
  left: 10px;
}

.header_back {
  width: 24px;
  height: 24px;
  vertical-align: middle;
}

.header_i_back {
  font-size: 22px;
  vertical-align: middle;
}

.header_right {
  right: 10px;
}
</style>
